import { render, staticRenderFns } from "./MetricReport.vue?vue&type=template&id=45bf61ac&scoped=true"
import script from "./MetricReport.vue?vue&type=script&lang=js"
export * from "./MetricReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf61ac",
  null
  
)

export default component.exports